import { createRoot } from "react-dom/client";
import App from "./App";
import "./index.css";

// Add Google Fonts for styling
const fontLinks = document.createElement('link');
fontLinks.href = "https://fonts.googleapis.com/css2?family=Open+Sans:wght@300;400;600;700&family=Playfair+Display:wght@400;500;600;700&display=swap";
fontLinks.rel = "stylesheet";
document.head.appendChild(fontLinks);

// Add FontAwesome for icons
const fontAwesome = document.createElement('link');
fontAwesome.href = "https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.0/css/all.min.css";
fontAwesome.rel = "stylesheet";
fontAwesome.integrity = "sha512-iecdLmaskl7CVkqkXNQ/ZH/XLlvWZOJyj7Yy7tcenmpD1ypASozpmT/E0iPtmFIB46ZmdtAc9eNBvH0H/ZpiBw==";
fontAwesome.crossOrigin = "anonymous";
fontAwesome.referrerPolicy = "no-referrer";
document.head.appendChild(fontAwesome);

// Also import from the installed package as a fallback
import '@fortawesome/fontawesome-free/css/all.min.css';

// Add title and meta tags for SEO
document.title = "SW Accounting | Professional Accounting Services Nationwide";
const metaDescription = document.createElement('meta');
metaDescription.name = "description";
metaDescription.content = "Sarah Willardsen offers expert accounting services nationwide with 20+ years of experience. QuickBooks certified professional providing virtual accounting services across all 50 states.";
document.head.appendChild(metaDescription);

const metaKeywords = document.createElement('meta');
metaKeywords.name = "keywords";
metaKeywords.content = "Remote Accounting, Virtual Bookkeeping, QuickBooks Expert, Sarah Willardsen Accounting, Nationwide Bookkeeping, Payroll, Financial Reporting, Online Accounting Services";
document.head.appendChild(metaKeywords);

// Schema.org markup for Google
const schemaScript = document.createElement('script');
schemaScript.type = "application/ld+json";
schemaScript.textContent = JSON.stringify({
  "@context": "https://schema.org",
  "@type": "AccountingService",
  "name": "SW Accounting",
  "url": "https://www.swaccountingpro.com",
  "logo": "https://www.swaccountingpro.com/logo.png",
  "image": "https://www.swaccountingpro.com/sarah-willardsen.jpg",
  "description": "Professional accounting services nationwide with 20+ years of experience. QuickBooks certified expert providing remote accounting solutions for businesses across the US.",
  "founder": {
    "@type": "Person",
    "name": "Sarah Willardsen"
  },
  "address": {
    "@type": "PostalAddress",
    "addressLocality": "Draper",
    "addressRegion": "Utah",
    "addressCountry": "US"
  },
  "areaServed": {
    "@type": "Country",
    "name": "United States"
  },
  "serviceArea": {
    "@type": "GeoShape",
    "name": "United States",
    "description": "Providing remote accounting services to businesses across all 50 states"
  },
  "telephone": "801-791-6900",
  "email": "sarah@swaccountingpro.com",
  "priceRange": "$$"
});
document.head.appendChild(schemaScript);

createRoot(document.getElementById("root")!).render(<App />);
